import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FiBarChart2 } from 'react-icons/fi';
import { API_URL } from '../config/api';
import './RelatorioHotspot.css';

const RelatorioHotspot = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchReport = async () => {
    try {
      setLoading(true);
      setError('');
      const token = localStorage.getItem('token');
      if (!token) {
        window.location.href = '/sysconect/adm-login';
        return;
      }
      const response = await axios.get(`${API_URL}/api/reports/hotspots`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setRows(response.data || []);
    } catch (err) {
      const status = err.response?.status;
      if (status === 401 || status === 403) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/sysconect/adm-login';
        return;
      }
      setError('Erro ao carregar relatório.');
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  if (loading) {
    return <div className="loading">Carregando relatório...</div>;
  }

  return (
    <div className="relatorio-hotspot">
      <div className="relatorio-header">
        <div>
          <h1>Relatório por Hotspot</h1>
          <p>Resumo de acessos agrupados por server_name</p>
        </div>
        <div className="relatorio-total">
          <FiBarChart2 /> {rows.length} hotspot(s)
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      {rows.length === 0 ? (
        <div className="no-acessos">
          <FiBarChart2 size={48} />
          <p>Nenhum acesso registrado</p>
        </div>
      ) : (
        <div className="relatorio-table-container">
          <table className="relatorio-table">
            <thead>
              <tr>
                <th>Hotspot</th>
                <th>Total</th>
                <th>Último Acesso</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={`${row.server_name}-${index}`}>
                  <td>{row.server_name || '-'}</td>
                  <td>{row.total}</td>
                  <td>{row.ultimo_acesso || '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RelatorioHotspot;
